import { Flex, Separator, VStack } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { CraNodeDetail } from "./node/CraNodeDetail";
import { CraWayDetail } from "./cra-way/CraWayDetail";
import { SurveyDetail } from "./survey/SurveyDetail";
import { useStores } from "../../../../shared/stores/RootStore";
import useAutoResizeMap from "../../../../hooks/useAutoResizeMap";
import { LifeCycleStage } from "../../../../cra/models/LifeCycleStage";
import { HlaWayDetail } from "../../../../hla/views/HlaWayDetail/HlaWayDetail";
import { MapQueryControls } from "../hla-query/ImportHlaControls";

const DetailBarBase: React.FC = () => {
  useAutoResizeMap();
  const { craNodeStore, craWayStore, hlaStore, mapQueryStore } = useStores();
  const selectedCraWay = craWayStore.getSelected();

  if (mapQueryStore.active) {
    return <MapQueryControls />;
  }

  if (craNodeStore.getSelected()) {
    return (
      <Flex
        flexShrink={0}
        flexDirection="column"
        w={selectedCraWay?.lifeCycleStage === LifeCycleStage.Review ? 540 : 320}
      >
        <CraNodeDetail />
      </Flex>
    );
  }
  if (selectedCraWay) {
    return (
      <Flex
        flexShrink={0}
        flexDirection="column"
        w={selectedCraWay.lifeCycleStage === LifeCycleStage.Review ? 540 : 320}
      >
        <CraWayDetail />
      </Flex>
    );
  }
  if (hlaStore.getSelected()) {
    return (
      <VStack
        width={"50%"}
        separator={<Separator orientation={"horizontal"} w="full" />}
      >
        <HlaWayDetail />
      </VStack>
    );
  }
  return (
    <Flex flexShrink={0} flexDirection="column" w={320}>
      <SurveyDetail />
    </Flex>
  );
};

export const DetailBar = observer(DetailBarBase);
